import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Select, Input} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import FormModal from './FormModal'
import UPM from '../../../constants/urlPermissionMappings'
import {PlusOutlined, SearchOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
const storage = window.localStorage

@inject('emailAddressStore', 'accountStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
  }
  formRef = React.createRef()

  componentDidMount() {
    const {emailAddressStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    emailAddressStore.onGetGroup({
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
    }).then(res=> {
      if (res?.code === 0) {
        this.formRef.current.setFieldsValue({
          'marketGroupId': res?.data[0]?.id,
        })
        emailAddressStore.onSearchJobAction({
          page: 1, 
          size: PAGE_SIZE_DEFAULT, 
          marketGroupId: res?.data[0]?.id
        })
        emailAddressStore.onGetResourcePool({
          configTypeList: ['3'],
          marketingGroupId: [res?.data[0]?.id],
        })
      }
    })
  }
  handleSearch = () => {
    const {emailAddressStore} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        'marketGroupId': fieldsValue.marketGroupId,
        'page': 1,
        'size': PAGE_SIZE_DEFAULT
      }
      emailAddressStore.onSearchJobAction(params)
      emailAddressStore.onGetResourcePool({
        configTypeList: ['3'],
        marketingGroupId: [fieldsValue.marketGroupId],
      })
    }).catch(err => {
    })
  }
  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }

  render() {
    const {emailAddressStore, location, t} = this.props
    const {groupList} = emailAddressStore
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 10]}>
            <Col span={6}>
              <Form.Item name="marketGroupId" label={t(`emailSend.marketingGroup`)}>
                <Select placeholder={t(`general.pleaseSelect`)} showSearch filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {groupList?.map(item => (<Select.Option key={item?.id} value={item?.id}>{item?.groupName}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            {/* <Col span={6}>
              <Form.Item name="configName" label={t(`emailSend.className`)} rules={[{ message: `${t(`general.pleaseEnter`)} ${t(`emailSend.className`)}` }]}>
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col> */}
            <Col span={18} style={{textAlign: 'right', marginTop: 30}}>
              <Button onClick={this.handleSearch} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchForm)
